export default "__VITE_ASSET__C7w9gKNx__"